<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div style="height: 100%">

    <list-page v-if="dataLevel === 1">
      <search-condition @search="resetSearch" :show-search="true" :show-shadow="false">
        <template #default>
          <date-range  v-model:start-time="searchInfo.startTime" v-model:end-time="searchInfo.endTime" class="double-width">
            <template #prefix>考勤时间</template>
          </date-range>
          <el-select v-model="searchInfo.projectId" placeholder="请选择项目" clearable filterable>
            <template #prefix>项目</template>
            <el-option v-for="item in projectList" :key="item.id" :value="item.id" :label="item.projectName"></el-option>
          </el-select>
          <el-select v-model="searchInfo.siteId" placeholder="请选择工地" clearable filterable>
            <template #prefix>工地</template>
            <el-option v-for="item in siteList" :key="item.id" :value="item.id" :label="item.siteName"></el-option>
          </el-select>
          <el-select v-model="searchInfo.classmateId" placeholder="请选择班组" clearable filterable>
            <template #prefix>班组</template>
            <el-option v-for="item in classmateList" :key="item.id" :value="item.id" :label="item.classmateName"></el-option>
          </el-select>
          <el-select v-model="searchInfo.lot" placeholder="请选择班组标段" clearable>
            <template #prefix>班组标段</template>
            <el-option v-for="item in lotList" :key="item.id" :value="item.dictCode" :label="item.dictName"/>
          </el-select>
        </template>
        <template #option>
          <page-button hasPerm="laborers:attendance:query" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button hasperm="laborers:attendance:export" el-type="success" @click="toExport">导出明细</page-button>
          <page-button hasperm="laborers:attendance:export" el-type="success" @click="toExport2">导出汇总</page-button>
          <!--          <page-button hasPerm="laborers:attendance:query" el-type="primary" @click="$router.push('/laborers/attendance/video')">考勤视频</page-button>-->
        </template>
      </search-condition>
      <list-table :show-shadow="false">
        <laborers-attendance-work-data :data-list="dataList" @toDetail="toDetail2" :level="dataLevel"/>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
    <list-page v-else-if="dataLevel === 2" :show-shadow="false">
      <laborers-attendance-label :data="currentData2" :level="2" @back2List="dataLevel = 1"/>
      <list-table :show-shadow="false">
        <laborers-attendance-work-data :data-list="dataList2" @toDetail="toDetail3" :level="dataLevel"  :attendance-today="attendanceToday"/>
      </list-table>
      <form-page v-model:page-number="searchInfo2.pageNumber" v-model:page-size="searchInfo2.pageSize"
                 :total-count="searchInfo2.totalCount" @onLoad="queryList2"/>
    </list-page>
    <list-page v-else-if="dataLevel === 3" :show-shadow="false">
      <laborers-attendance-label :data="currentData3" :level="3" @back2List="dataLevel = 2"/>
      <list-table :show-shadow="false">
        <laborers-attendance-work-data :data-list="dataList3" :level="dataLevel" :current-data="currentData3"  :attendance-today="attendanceToday"/>
      </list-table>
      <form-page v-model:page-number="searchInfo3.pageNumber" v-model:page-size="searchInfo3.pageSize"
                 :total-count="searchInfo3.totalCount" @onLoad="queryList3"/>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import Util from "@/util/util";
import excelUtil from "@/util/excelUtil";
import {useRoute, useRouter} from "vue-router";
import DateRange from "@/components/h5/date/YqDateRange.vue";
import attendanceApi from "@/api/dz-luqiao/attendanceApi";
import LaborersAttendanceWorkData from "@/views/h5/luqiao/laborers/attendance/result/LaborersAttendanceWorkData.vue";
import LaborersAttendanceLabel from "@/views/h5/luqiao/laborers/attendance/result/LaborersAttendanceLabel.vue";


export default {
  props: {
    projectList: {default: () => []}, // 项目列表
    siteList: {default: () => []},
    classmateList: {default: () => []},
    lotList: {default: () => []},
    checkName: {default: ""},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LA",
  components: {
    SearchCondition,
    FormPage,
    ListTable,
    ListPage,
    DateRange, LaborersAttendanceWorkData, LaborersAttendanceLabel
  },
  data() {
    return {
      searchInfo: {
        checkType: "WORK",
        searchType: 1
      },
      dataList: [],
      dataLevel: 0,
      attendanceToday: {}, // 打卡考勤的具体时间
      // 2级页面数据
      searchInfo2: {},
      dataList2: [],
      currentData2: {},
      // 3级页面数据
      searchInfo3: {},
      dataList3: [],
      currentData3: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    if (this.route.query.type === 'WORK' && this.route.query.id && this.route.query.date) {

    } else {
      this.dataLevel = 1;
      this.searchInfo.startTime = new Date(new Date().getTime()).format("yyyy-MM-dd") + " 00:00:00";
      this.searchInfo.endTime = new Date().format("yyyy-MM-dd") + " 23:59:59";
      this.resetSearch();
    }

  },
  methods: {
    async queryList() {
      if (this.dataLevel === 1) {
        let param = {
          ...this.searchInfo,
          searchType: 1,
          checkType: "WORK"
        }
        // 1级页面，查询
        const {records, totalCount} = await attendanceApi.list(param)
        this.getInfo(records);
        this.dataList = records;
        this.searchInfo.totalCount = totalCount;
      }
    },
    toExport() {
      let p = {...this.searchInfo, checkType: "WORK", checkName: this.checkName};
      excelUtil.exportExcel("/luqiao/attendance/excelExportWorkers", p, "考勤数据");
    },
    toExport2() {
      let p = {...this.searchInfo, checkType: "WORK", checkName: this.checkName};
      excelUtil.exportExcel("/luqiao/attendance/excelExportWorkersAll", p, "考勤数据");
    },
    getInfo(list) {
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < this.lotList.length; j++) {
          if (this.lotList[j].dictCode === list[i].lot) {
            list[i].lotName = this.lotList[j].dictName;
          }
        }
      }
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toDetail2(data) {
      if (!data.attendanceDate) {
        this.$message.error("当前施工班组没有对应的劳务人员");
        return;
      }
      this.searchInfo2 = {
        projectId: data.projectId,
        siteId: data.siteId,
        classmateId: data.classmateId,
        attendanceDate: data.attendanceDate.split(" ")[0],
        pageNumber: 1
      };
      this.dataLevel = 2;
      this.currentData2 = {
        ...data,
        attendanceDate: data.attendanceDate.split(" ")[0],
      };
      // 2级页面时，查询打卡的具体时间
      let d = {classmateId: data.classmateId, date: data.attendanceDate.split(" ")[0]}
      attendanceApi.getAttendanceToday(d).then(res => this.attendanceToday = res);
      this.resetSearch2();
      // this.$router.push(`/laborers/attendance/workDetail?pid=${data.projectId}&sid=${data.siteId}&cid=${data.classmateId}&date=${data.attendanceDate.split(" ")[0]}`)
    },
    resetSearch2() {
      this.searchInfo2.pageNumber = 1;
      this.queryList2();
    },
    queryList2() {
      let param = {
        ...this.searchInfo2,
        checkType: "WORK",
        searchType: 2
      }
      attendanceApi.list(param).then(res => {
        this.getInfo(res.records);
        this.dataList2 = res.records;
        this.searchInfo2.totalCount = res.totalCount;
      });
    },
    toDetail3(data) {
      this.searchInfo3 = {
        projectId: data.projectId,
        siteId: data.siteId,
        workerId: data.workersId,
        attendanceDate: this.currentData2.attendanceDate.substring(0, 10),
        classmateId: data.classmateId,
        checkType: data.checkType,
      }
      this.dataLevel = 3;
      this.currentData3 = {
        ...data,
        attendanceDate: data.attendanceDate.split(" ")[0],
      };
      this.resetSearch3();
    },
    resetSearch3() {
      this.searchInfo3.pageNumber = 1;
      this.queryList3();
    },
    queryList3() {
      attendanceApi.queryListDetail(this.searchInfo3).then(res => {
        this.dataList3 = res.records;
        this.searchInfo3.totalCount = res.totalCount;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.error-status{
  color: var(--el-color-danger);
}
</style>